import { render, staticRenderFns } from "./CreateNpa.vue?vue&type=template&id=42733a64&scoped=true"
import script from "./CreateNpa.vue?vue&type=script&lang=js"
export * from "./CreateNpa.vue?vue&type=script&lang=js"
import style0 from "./CreateNpa.vue?vue&type=style&index=0&id=42733a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42733a64",
  null
  
)

export default component.exports